import { Link, useNavigate, useParams, useLoaderData } from "react-router-dom";
import { useState } from "react";

import { OpcionesEstadosTratamientos } from '../components/OpcionesEstadosTratamientos';

import { MindfulnessUpdate } from "./MindfulnessUpdate";
import { MindfulnessDelete } from "./MindfulnessDelete";

export function MindfulnessEdit(props) {
  const mindfulness = useLoaderData();
  const navigate = useNavigate();
  const errorMessage = mindfulness.message;

  const [isCreatingButton, setIsCreatingButton] = useState(false);
  const [isDeletingButton, setIsDeletingButton] = useState(false);

  const [mindResp, setMindResp] = useState(mindfulness.meta?.mindResp);
  const [mindFecha, setMindFecha] = useState(mindfulness.meta?.metaFecha);
  const [mindNumses, setMindNumses] = useState(mindfulness.meta?.mindNumses);
  const [mindObs, setMindObs] = useState(mindfulness.meta?.mindObs);
  const [mindMedio, setMindMedio] = useState(mindfulness.meta?.mindMedio);
  const [mindTipo, setMindTipo] = useState(mindfulness.meta?.mindTipo);
  const [mindPract, setMindPract] = useState(mindfulness.meta?.mindPract);
  const [mindPractEsp, setMindPractEsp] = useState(
    mindfulness.meta?.mindPractEsp
  );
  const [mindPractSem, setMindPractSem] = useState(
    mindfulness.meta?.mindPractSem
  );
  const [mindPractTem, setMindPractTem] = useState(
    mindfulness.meta?.mindPractTem
  );

  const [mindEstado, setMindEstado] = useState(mindfulness.meta?.mindEstado ||'seguimiento');

  let { tratamientoId } = useParams();
  let { pacienteId } = useParams();
  let mindfulnessId = mindfulness.id;

  const mindDate = new Date(mindfulness.date);
  const diffDate = Math.abs(new Date() - mindDate) / 36e5;

  const submitMindfulness = async (e) => {
    e.preventDefault();
    setIsCreatingButton(true);
    console.log(
      mindResp,
      mindFecha,
      mindNumses,
      mindObs,
      mindMedio,
      mindTipo,
      mindPract,
      mindPractEsp,
      mindPractSem,
      mindPractTem,
      mindEstado,
      tratamientoId,
      pacienteId,
      mindfulnessId
    );
    try {
      await MindfulnessUpdate(
        mindResp,
        mindFecha,
        mindNumses,
        mindObs,
        mindMedio,
        mindTipo,
        mindPract,
        mindPractEsp,
        mindPractSem,
        mindPractTem,
        mindEstado,
        tratamientoId,
        pacienteId,
        mindfulnessId
      ).then(
        (val) => {
          navigate(
            `../${tratamientoId}/seguimiento/mindfulness/${mindfulnessId}`
          );
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  const deleteItem = async (e) => {
    e.preventDefault();
    setIsDeletingButton(true);
    try {
      await MindfulnessDelete(mindfulnessId).then(
        (val) => {
          window.location.replace("../");
        },
        (error) => {
          console.log(error);
        }
      );
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div id='content'>
        {mindfulness?.length === 0 ? (
          <div>Cargando...</div>
        ) : errorMessage ? (
          <p>{errorMessage}</p>
        ) : (
          <form id='formUpdatelement' onSubmit={submitMindfulness}>
            <fieldset id='disabledContainer'>
              <div className='grid--2col'>
                <div className='field'>
                  <label htmlFor='mindResp'>Responsable</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='mindResp'
                      required
                      type='text'
                      value={mindResp}
                      onChange={(e) => setMindResp(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='mindFecha'>Fecha visita</label>
                  <div className='control'>
                    <input
                      className='input'
                      id='mindFecha'
                      required
                      type='date'
                      value={mindFecha}
                      onChange={(e) => setMindFecha(e.target.value)}
                    />
                  </div>
                </div>
                <div className='field'>
                  <label htmlFor='mindNumses'>Número de sesión</label>
                  <div className='control'>
                  {props.userRole.includes('administrador') ? (
                    <input
                      className='input'
                      id='mindNumses'
                      required
                      type='number'
                      value={mindNumses}
                      onChange={(e) => setMindNumses(e.target.value)}
                    />
                  ) : (
                    <input
                      className='input'
                      id='mindNumses'
                      required
                      disabled
                      type='number'
                      value={mindNumses}
                      onChange={(e) => setMindNumses(e.target.value)}
                    />
                  )}
                  </div>
                </div>

                <div className='field'>
                  <label htmlFor='mindMedio'>Medio</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindMedio'
                        required
                        name='mindMedio'
                        value={mindMedio}
                        onChange={(e) => setMindMedio(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='presencial'>Presencial</option>
                        <option value='videoconferencia'>
                          Videoconferencia
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                {(props.userRole.includes('administrador')) && (
                <div className='field'>
                  <label htmlFor='mindEstado'>Estado de seguimiento</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindEstado'
                        name='mindEstado'
                        value={mindEstado}
                        onChange={(e) => setMindEstado(e.target.value)}
                      >
                        { OpcionesEstadosTratamientos.map((option) => (
                          <option
                            key={option.value}
                            value={option.value}
                            disabled={option.disabled}
                          >
                            {option.label}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                )}

                <div className='field'>
                  <label htmlFor='mindTipo'>Tipo</label>
                  <div className='control'>
                    <div className='select'>
                      <select
                        className='select'
                        id='mindTipo'
                        required
                        name='mindTipo'
                        value={mindTipo}
                        onChange={(e) => setMindTipo(e.target.value)}
                      >
                        <option disabled value=''>
                          -- Selecciona una opción --
                        </option>
                        <option value='general'>General</option>
                        <option value='sueno'>Sueño</option>
                      </select>
                    </div>
                  </div>
                </div>


                {mindNumses === 1 ? (
                  <>
                    <div className='field key' data-key={mindPract?.toString()}>
                      <label htmlFor='mindPract'>
                        ¿Ha practicado o practica Mindfulness?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='mindPract'
                            required
                            name='mindPract'
                            value={mindPract}
                            onChange={(e) => setMindPract(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='si-pasado'>Sí, en el pasado</option>
                            <option value='si-actualmente'>
                              Sí actualmente
                            </option>
                            <option value='si-pasado-actualmente'>
                              Sí, en el pasado y actualmente
                            </option>
                            <option value='no'>No</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='field lock'>
                      <label htmlFor='mindPractEsp'>
                        Especificar frecuencia
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          id='mindPractEsp'
                          type='text'
                          value={mindPractEsp}
                          onChange={(e) => setMindPractEsp(e.target.value)}
                        />
                      </div>
                    </div>
                  </>
                ) : (
                  <>
                    <div className='field'>
                      <label htmlFor='mindPractSem'>
                        ¿Cuántas veces ha practicado Mindfulness en la última
                        semana?
                      </label>
                      <div className='control'>
                        <div className='select'>
                          <select
                            className='select'
                            id='mindPractSem'
                            required
                            name='mindPractSem'
                            value={mindPractSem}
                            onChange={(e) => setMindPractSem(e.target.value)}
                          >
                            <option disabled value=''>
                              -- Selecciona una opción --
                            </option>
                            <option value='nada'>Nada</option>
                            <option value='1-2'>1-2 veces</option>
                            <option value='3-4'>3-4 veces</option>
                            <option value='5-7'>5-7 veces</option>
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className='field'>
                      <label htmlFor='mindPractTem'>
                        ¿Cuánto tiempo ha practicado Mindfulness cada vez en la
                        última semana?
                      </label>
                      <div className='control'>
                        <input
                          className='input'
                          name='mindPractTem'
                          id='mindPractTem'
                          value={mindPractTem}
                          onChange={(e) => setMindPractTem(e.target.value)}
                        ></input>
                      </div>
                    </div>
                  </>
                )}
              </div>

              <div className='field'>
                <label className='' htmlFor='mindObs'>
                  Observaciones
                </label>
                <div className='control'>
                  <textarea
                    className='textarea'
                    name='mindObs'
                    id='mindObs'
                    value={mindObs}
                    onChange={(e) => setMindObs(e.target.value)}
                  ></textarea>
                </div>
              </div>
            </fieldset>
          </form>
        )}
      </div>
      {!errorMessage && (
        <div id='actions'>
          {(diffDate <= 72 || props.userRole.includes('administrador')) && (
            <button
              className='button is-link'
              id='saveButton'
              form='formUpdatelement'
              type='submit'
              disabled={isCreatingButton}
            >
              {isCreatingButton ? <div className="spinner"></div> : 'Guardar'}
            </button>
          )}
          <Link
            className='button is-link is-light'
            to={`../${tratamientoId}/seguimiento/mindfulness/${mindfulness.id}`}
          >
            Cancelar
          </Link>
          {props.userRole.includes('administrador') && (
            <button
              className='button is-danger'
              id='deleteButton'
              disabled={isDeletingButton}
              onClick={deleteItem}>
              {isDeletingButton ? <div className="spinner"></div> : 'Eliminar'}
            </button>
          )}
        </div>
      )}
    </>
  );
}
